import { Card, Grid, makeStyles } from '@material-ui/core';
import React, { FC } from 'react';

import { ICommonProps, ITrack } from '../../types';
import Cluster from '../Cluster';
import Details from '../Details';

interface IProps extends ICommonProps {
  eventId: number;
  track: ITrack;
  onImportant: (img_file) => void;
  showCluster?: boolean;
}

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.default,
    display: 'flex',
  },
}));

const Tracks: FC<IProps> = ({
  eventId,
  track,
  isSelectingPeople,
  onItemClick,
  onImportant,
  showCluster,
}) => {
  const classes = useStyles();

  return (
    <Card className={classes.root}>
      <Grid container spacing={1}>
        <Details
          eventId={eventId}
          track={track}
          isSelectingPeople={isSelectingPeople}
          onItemClick={onItemClick}
          onImportant={onImportant}
          showCluster={showCluster}
        />
        {showCluster && track.cluster_id && (
          <Cluster cluster_id={track.cluster_id} />
        )}
      </Grid>
    </Card>
  );
};

export default Tracks;
